module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fmd-566.e0df8055905e1884.png"+" 566w",
        images: [{path: "https://static.sniffspot.com/packs/img/fmd-566.e0df8055905e1884.png",width: 566,height: 120}],
        src: "https://static.sniffspot.com/packs/img/fmd-566.e0df8055905e1884.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/fmd-566.e0df8055905e1884.png"},
        
        width: 566,
        height: 120
      }